import {
  SET_TOKENS,
  LOGIN_REQUEST,
  LOGIN_FAILED,
  LOGIN_SUCCESSFUL,
  AUTH_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESSFUL,
  LOGOUT_FAILED,
  SESSION_MAX_AGE,
  SET_SESSION_EXPIRY,
  RESET_LOCKOUT,
  INITIATE_PASSWORD_CHANGE,
  SET_USERNAME,
  SET_AUTHENTICATED_WITH_KEYCLOAK,
  START_SPINNER,
  STOP_SPINNER,
  SET_FAILURE_MESSAGE,
} from "./types";

import { initialState } from "../state";
import { AuthenticationActionType } from "./types";

const authentication = (
  state = initialState.authentication,
  action: AuthenticationActionType
) => {
  switch (action.type) {
    case SET_TOKENS:
      return {
        ...state,
        accessToken: action.tokenData.accessToken,
        refreshToken: action.tokenData.refreshToken,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        failureMessage: null,
      };

    case LOGIN_SUCCESSFUL:
      return {
        ...state,
        isFetching: false,
        loginFailed: false,
        isAuthenticated: true,
        lockOutDuration: 0,
        user: action.user,
        authenticatedWithKeycloak: action.authenticatedWithKeycloak,
      };

    case LOGIN_FAILED:
      return {
        ...state,
        isAuthenticated: false,
        loginFailed: true,
        isFetching: false,
        failureMessage: action.message,
      };

    case SET_FAILURE_MESSAGE:
      return {
        ...state,
        failureMessage: action.message,
      };

    case INITIATE_PASSWORD_CHANGE:
      return {
        ...state,
        initiatePasswordChange: true,
      };

    case SET_USERNAME:
      return {
        ...state,
        user: action.user,
      };

    case SET_AUTHENTICATED_WITH_KEYCLOAK:
      return {
        ...state,
        authenticatedWithKeycloak: action.authenticatedWithKeycloak,
      };

    case AUTH_FAILURE:
      return { ...state, isAuthenticated: false };

    case LOGOUT_REQUEST:
      return { ...state, isLoggingOut: true, logoutFailureMessage: null };

    case LOGOUT_SUCCESSFUL:
      return initialState;

    case LOGOUT_FAILED:
      return {
        ...state,
        logoutFailureMessage: action.message,
        isLoggingOut: true,
      };

    case SESSION_MAX_AGE:
      return { ...state, sessionTotalLength: action.sessionTotalLength };

    case SET_SESSION_EXPIRY:
      return { ...state, sessionExpiry: action.sessionExpiry };

    case RESET_LOCKOUT:
      return { ...state, lockOutDuration: 0 };

    case START_SPINNER:
      return { ...state, isFetching: true, failureMessage: null };

    case STOP_SPINNER:
      return { ...state, isFetching: false };

    default:
      return state;
  }
};

export default authentication;
